import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import MarketplaceList from './MarketplaceList';
import MarketplaceShow from './MarketplaceShow';
import MarketplaceCreate from './MarketplaceCreate';

export default {
	list: MarketplaceList,
	show: MarketplaceShow,
	create: MarketplaceCreate,
	icon: AddShoppingCartIcon,
};
